export default __webpack_public_path__ + "static/media/gun-screen.39abaf7e.mp4";